

















































































import { Component, Prop, Mixins, Vue, Ref } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IClientTemplateSlotMapping, ITemplate } from "@/models/templates";
import { TemplateTypes } from "@/data/enums/templates";
import HasValidation from "@/mixins/HasValidation";
import TemplatesSlotsMixin from "@/mixins/templatesSlotsMixin";
import TemplatesProvider from "@/components/app/global/templates/templatesProvider.vue";

const TemplateSlotsClass = Vue.extend(TemplatesSlotsMixin);

@Component({
  components: {
    TemplatesProvider,
    "templates-list-select": () =>
      import("@/components/app/global/templates/templatesListSelect.vue")
  }
})
export default class ClientTemplatesMappingModal extends Mixins(HasValidation) {
  // Props
  @Prop({ default: null })
  public readonly objectType!: string;

  @Prop({ default: null })
  public readonly objectId!: string;

  @Prop({ default: null })
  public readonly preselectedSlotId!: string;

  @Prop({ required: false })
  public readonly mapping?: IClientTemplateSlotMapping;

  @Prop({ default: null })
  public readonly filterTemplateCategoryId!: string;

  @Ref()
  public readonly templatesProvider!: TemplatesProvider;

  // Data
  public form = this.initForm();
  public templateSearch = "";
  public isProcessing = false;
  public isLoadingTemplates = true;
  public isLoadingSlots = true;
  public hookLogEventsMap = {};
  public templateType = TemplateTypes.CLIENT_TEMPLATE;
  public selectedTemplate: ITemplate | null = this.mapping?.template || null;

  public slotsMixin: TemplatesSlotsMixin = new TemplateSlotsClass({
    propsData: { scope: `$${this.objectType}_slots` }
  });

  public created() {
    this.loadData();
  }

  // Life-cycle methods
  public async loadData() {
    this.slotsMixin.getAll().then(() => (this.isLoadingSlots = false));
  }

  public reloadData() {
    this.loadData();
  }

  public beforeDestroy() {
    this.slotsMixin.$destroy();
  }

  // Computed

  public get formIsDisabled() {
    return this.$_.isEqual(this.form, this.initForm()) || this.hasErrors;
  }

  public get selectedSlot() {
    return this.slotsMixin.slots?.find(i => i.id === this.form.slot_id);
  }

  // Methods

  public onSelectTemplate(template: ITemplate | null) {
    this.selectedTemplate = template;
    this.form.template_id = this.selectedTemplate?.id ?? null;
  }

  public onSlotChange() {
    // Reset template selection if category doesn't match slot's category
    // They must be same to able to save
    if (
      this.selectedSlot?.category?.code !==
      this.selectedTemplate?.category?.code
    ) {
      this.form.template_id = undefined;
      this.selectedTemplate = null;
    }
  }

  public async addTemplateModal() {
    this.$store.dispatch(`data/${DataModules.TEMPLATES}/openAddEditModal`, {
      props: {
        categoryCode: this.selectedSlot?.category?.code,
        showCode: false,
        templateType: TemplateTypes.CLIENT_TEMPLATE
      },
      events: {
        success: async (template: ITemplate) => {
          await this.templatesProvider.reloadData();
          this.onSelectTemplate(template);
        }
      }
    });
  }

  public initForm() {
    return {
      slot_id: this.preselectedSlotId,
      template_id: null
    } as { slot_id?: string | null; template_id?: string | null };
  }

  public createMapping(data) {
    return this.$store.dispatch(
      `data/${DataModules.TEMPLATES_CLIENT_MAPPINGS}/create`,
      {
        objectType: this.objectType,
        objectId: this.objectId,
        data
      }
    );
  }

  public deleteMapping() {
    return this.$store.dispatch(
      `data/${DataModules.TEMPLATES_CLIENT_MAPPINGS}/remove`,
      {
        id: this.mapping?.id
      }
    );
  }

  public async validateBeforeSubmit() {
    this.isProcessing = true;
    try {
      const isValid = await this.validate();
      if (!isValid) throw this.$t("_sentence.form_is_not_valid");

      if (this.mapping?.id) await this.deleteMapping();
      await this.createMapping(this.form);

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.successfully_saved")
      });
      this.$emit("success");
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
